import { __awaiter, __generator } from "tslib";
import { Simulate } from 'react-dom/test-utils';
import { UploaderState } from '.';
import { createFileSelectorDriver, createFloaterMenuDriver } from '../..';
import { compKey } from './key';
export var createCompactImageUploaderDriver = function (wrapper, global) {
    var base = wrapper.$("." + compKey);
    var selectFileDriver = createFileSelectorDriver(base);
    var menu = createFloaterMenuDriver(global);
    var hover = function () { return __awaiter(void 0, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = (_a = Simulate).mouseOver;
                return [4 /*yield*/, base.getNative()];
            case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
        }
    }); }); };
    var clickIcon = function (iconCn) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, hover()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, base.$("." + iconCn).click()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        isUploadNewState: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.hasClass("" + UploaderState.UPLOAD_NEW)];
        }); }); },
        isReplaceState: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.hasClass("" + UploaderState.REPLACE)];
        }); }); },
        isErrorState: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.hasClass("" + UploaderState.ERROR)];
        }); }); },
        isImageShown: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.hasClass("with-image")];
        }); }); },
        getImageUrl: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, base.attr('data-image-url')];
                case 1: return [2 /*return*/, (_a.sent()) || ''];
            }
        }); }); },
        selectImage: function (file) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, 1000); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, selectFileDriver.selectFile(file)];
                }
            });
        }); },
        removeImage: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, clickIcon('replace-icon-wrapper')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, menu.selectByClass('remove-image-menu-item')];
                }
            });
        }); },
        clickReplaceIcon: function () { return clickIcon('replace-icon-wrapper'); },
        getMenuOptions: function () { return menu.getItemValues(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map